<template>
  <div v-if="info" class="property-container">
    <section class="banner">
      <img :src="info.banner" alt="" />
    </section>
    <section class="main">
      <section class="sec-01">
        <section class="title-wrap">
          <img
            class="title-img"
            src="../../assets/img/property-2021/title_background.png"
            alt=""
          />
        </section>
        <div class="bg-text">
          <p>{{ info.introduce }}</p>
        </div>
      </section>
      <section class="sec-02" v-if="info.topics">
        <img
          class="bg-decorate"
          src="../../assets/img/property-2021/img_yinhao.png"
          alt=""
        />
        <section class="title-wrap">
          <img
            class="title-img"
            src="../../assets/img/property-2021/title_forumtheme.png"
            alt=""
          />
          <img
            class="title-tip"
            src="../../assets/img/property-2021/title_theme.png"
            alt=""
          />
        </section>
        <div class="bg-text">
          <p>{{ info.topics[0].introduce }}</p>
        </div>
      </section>
      <section
        class="sec-03"
        v-if="info.setting_introduce && info.setting_introduce.length > 0"
      >
        <div class="part part-1">
          <img
            src="../../assets/img/property-2021/banner_forumtopic.png"
            alt=""
          />
        </div>
        <div
          v-for="(item, index) in info.setting_introduce"
          :key="index"
          class="part part-other"
          :class="'part-' + Number(index + 2)"
        >
          <h3>{{ item.title }}</h3>
          <p>{{ item.summary }}</p>
        </div>
      </section>
      <section class="sec-04">
        <div class="sec-04-container">
          <img
            class="title"
            src="../../assets/img/property-2021/title_agenda.png"
            alt=""
          />
          <div class="time-div">
            <i class="time-icon"></i>
            <span>{{ info.topics[0].date.replace(/-/g, ".") }}</span>
            <i class="line-icon"></i>
            <i class="addr-icon"></i>
            <span class="addr-text" :title="info.topics[0].address">{{
              info.topics[0].address
            }}</span>
          </div>
          <div class="time-line" v-if="info.topics[0].flows">
            <ul style="padding-right: 56px; border-right: 1px solid #e5ecff">
              <template v-for="(item, index) in info.topics[0].flows">
                <li :key="index" v-if="index < 4">
                  <span class="time-num">{{ item.time }}</span>
                  <span class="time-text">{{ item.title }}</span>
                </li>
              </template>
            </ul>
            <ul style="padding-left: 56px">
              <template v-for="(item, index) in info.topics[0].flows">
                <li :key="index" v-if="index >= 4">
                  <span class="time-num">{{ item.time }}</span>
                  <span class="time-text">{{ item.title }}</span>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </section>
      <section class="sec-05">
        <div class="left">
          <img
            src="../../assets/img/property-2021/title_awards.png"
            alt=""
          />
        </div>
        <div class="right">
          <div class="right-cell" style="margin-bottom: 100px;">
            <div class="cell-line" style="margin-bottom: 29px;">
              <i class="awards-icon" />
              <span>房企类</span>
            </div>
            <div class="cell-content">
              <ul class="line">
                <li>年度区域贡献大奖</li>
                <li>年度最佳城市运营商</li>
                <li>年度最佳企业公民大奖</li>
                <li>年度房地产行业贡献大奖</li>
              </ul>
              <ul class="line">
                <li>年度中国房地产绿色责任公司</li>
                <li>年度中国房地产最具稳健性公司</li>
                <li>年度中国房地产最具成长性企业</li>
                <li>年度中国房地产最具融资能力企业</li>
              </ul>
            </div>
          </div>
          <div class="right-cell">
            <div class="cell-line" style="margin-bottom: 29px;">
              <i class="awards-icon" />
              <span>房企类</span>
            </div>
            <div class="cell-content">
              <ul class="line_1">
                <li>年度最佳低碳社区</li>
                <li>年度最佳设计楼盘</li>
                <li>年度最佳人居楼盘</li>
                <li>年度最佳城市综合体</li>
              </ul>
              <ul class="line_1">
                <li>年度最具国际化楼盘</li>
                <li>年度最佳海岸豪宅大奖</li>
                <li>年度最具投资价值CBD公寓</li>
                <li>年度最具收藏价值豪华物业</li>
              </ul>
              <ul class="line_1">
                <li>年度最佳生活配套社区</li>
                <li>年度最具投资价值豪宅</li>
                <li>年度最具投资价值地产</li>
                <li>年度最佳旅游休闲地产</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="sec-06">
        <img
          class="sec-06-title"
          src="../../assets/img/property-2021/title_news.png"
          alt=""
        />
        <div class="container-inner">
          <div class="swiper-container">
            <div
              v-if="info.information.banner && info.information.banner.length"
              class="swiper-box mt40 mb20"
            >
              <swiper
                style="width: 100%; height: 488px"
                :options="swiperOption">
                <swiper-slide
                  @click.native="onLink(item.link)"
                  class="swiper-slide"
                  v-for="(item, index) in info.information.banner"
                  :key="index"
                >
                  <div class="swiper-img-wrap">
                    <img :src="item.banner" alt="" />
                  </div>
                  <div class="swiper-item-text">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.summary }}</p>
                  </div>
                </swiper-slide>
                <!-- 分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
                <!-- 左右箭头 -->
                <div
                  @click.stop
                  class="swiper-button-prev"
                  slot="button-prev"
                ></div>
                <div
                  @click.stop
                  class="swiper-button-next"
                  slot="button-next"
                ></div>
              </swiper>
            </div>
          </div>
          <div
            class="relative-news"
            v-if="info.information.arts && info.information.arts.length > 0"
          >
            <h3>相关新闻</h3>
            <ul class="news-list">
              <li
                v-for="(item, index) in info.information.arts"
                :key="index"
                @click="onLink(item.link)"
              >
                <p>{{ item.title }}</p>
                <span class="time-icon-two">{{ item.ago }}</span>
              </li>
            </ul>
          </div>
          <div class="review-news">
            <section class="title-wrap">
              <img
                class="title-img"
                src="../../assets/img/property-2021/title_pastevents.png"
                alt=""
              />
            </section>
            <!--                        <div class="flex-row">-->
            <ul class="re-list">
              <li
                v-for="(item, index) in info.retrospects"
                :key="index"
                @click="onLink(item.link)"
              >
                <h3>{{ item.title }}</h3>
                <p>{{ item.summary }}</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="sec-07">
        <img src="../../assets/img/property-2021/bg_organization.png" alt="" />
      </section>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: null,
      swiperOption: {
        //显示分页
        pagination: {
          el: ".swiper-pagination",
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: false,
      },
    };
  },
  methods: {
    getTopicsInfo() {
      const { forum_id = null } = this.$route.query;

      this.$api.topics.getTopicsInfo({ forum_id }).then((res) => {
        if (res.status === "success") {
          this.info = res.data;
          document.title = this.info.title;
        }
      });
    },
    onLink(link = null) {
      console.info(275)
      if (!link) {
        return;
      }

      window.open(link);
    },
  },
  created() {
    this.getTopicsInfo();
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: DIN;
  src: url("../../assets/font/DIN-Bold.otf");
}
p,
h1,
h2,
h3 {
  padding: 0;
  margin: 0;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
img {
  max-width: unset;
  max-height: unset;
}
.property-container {
  width: 100%;
  background: rgba(250, 250, 250, 1);
  .banner {
    position: relative;
    z-index: 999;
    img {
      width: 100%;
    }
  }
  .main {
    width: 1200px;
    margin: -15px auto 0;
    background: rgba(255, 255, 255, 1);
    .title-wrap {
      text-align: center;
    }
    .title-img {
      height: 38px;
    }
    .bg-text {
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      width: 987px;
      margin: 29px auto 0;
      p {
        margin: 0;
        white-space: pre-line;
        word-wrap: break-word;
      }
    }
    .sec-other {
      position: relative;
      top: -10px;
    }
    .sec-07 img {
      width: 100%;
    }
    .sec-06 {
      background: #fff;
    }
    .sec-06-title {
      width: 100%;
    }
    .container-inner {
      padding: 26px 101px 105px 99px;
    }

    .relative-news h3 {
      font-size: 16px;
      color: #343434;
      line-height: 24px;
      margin: 24px 0 18px;
      padding-left: 14px;
      display: flex;
      align-items: center;
    }
    .relative-news h3:before {
      content: "";
      width: 4px;
      height: 14px;
      background: #407afa;
      position: relative;
      left: -14px;
    }
    .news-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .news-list li {
      width: 30%;
      padding-bottom: 15px;
      cursor: pointer;
    }
    .news-list li:nth-child(3n-1) {
      margin: 0 25px;
      padding: 0 24px;
      border-left: 1px solid rgba(222, 222, 222, 1);
      border-right: 1px solid rgba(222, 222, 222, 1);
      width: 35%;
    }

    .news-list li p {
      padding: 15px 0;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #444444;
      line-height: 24px;
      width: 300px;
    }
    .news-list li:nth-child(-n + 3) p {
      padding: 0 0 15px;
    }
    .news-list li:nth-last-child(-n + 3) {
      padding-bottom: 0;
    }

    .time-icon-two {
      font-size: 15px;
      color: #9a9a9a;
      display: inline-flex;
      align-items: center;
    }
    .time-icon-two:before {
      content: "";
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url("../../assets/img/property/icon_time.png") no-repeat;
      background-size: cover;
      margin-right: 8px;
    }
    .review-news .title-wrap {
      margin: 76px 0 30px;
    }
    /*.flex-row{*/
    /*    display: flex;*/
    /*    */
    /*}*/
    .re-list {
      display: flex;
      flex-wrap: wrap;
    }
    /*.re-list:nth-child(2){*/
    /*    margin:0 35px;*/
    /*}*/
    .re-list li {
      width: 30%;
      padding-top: 20px;
      margin-right: 35px;
      text-align: justify;
      cursor: pointer;
      &:nth-child(-n + 3) {
        border-top: 3px solid #407afa;
        padding-top: 30px;
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
      h3 {
        font-size: 14px;
        color: #444444;
        line-height: 24px;
      }
      p {
        font-size: 13px;
        color: #9a9a9a;
        line-height: 23px;
      }
    }

    .sec-05 {
      display: flex;
      justify-content: space-between;
      padding: 104px 0 82px;
      padding-left: 100px;
      box-sizing: border-box;
      .left img {
        height: 52px;
      }
      .right {
        width: 860px;
        padding-left: 100px;
        min-height: 542px;
        background: url('../../assets/img/property-2021/bg_awards.png') no-repeat;
        background-size: 100%;
        box-sizing: border-box;
        .right-cell {
          width: 670px;
          .cell-line {
            width: 100%;
            height: 30px;
            background: url("../../assets/img/property-2021/bg_time.png") no-repeat
              left top;
            background-size: 100% auto;
            font-size: 20px;
            font-family: DIN;
            font-weight: bold;
            color: #ffffff;
            display: flex;
            align-items: center;
            margin-bottom: 29px;
            padding-left: 20px;
            box-sizing: border-box;
            .awards-icon {
              width: 17px;
              height: 17px;
              background: url('../../assets/img/property-2021/awards.png') no-repeat;
              background-size: 100%;
              margin-right: 8px;
            }
          }
          .cell-content {
            display: flex;
            ul li:not(:last-child) {
              margin-bottom: 10px;
            }
            .line:not(:last-child) {
              padding-right: 122px;
              margin-right: 122px;
              border-right: 1px solid #E5ECFF;
            }
            .line_1:not(:last-child) {
              padding-right: 40px;
              margin-right: 40px;
              border-right: 1px solid #E5ECFF;
            }
          }
        }
      }
    }

    .sec-04 {
      padding-left: 440px;
      padding-top: 200px;
      padding-bottom: 25px;
      background: url("../../assets/img/property-2021/bg_agenda.png") no-repeat
        top left;
      background-size: 100% 100%;
      position: relative;
      box-sizing: border-box;
      .sec-04-container {
        width: 670px;
        .title {
          height: 52px;
          margin-bottom: 37px;
          display: block;
        }
      }
      .time-div {
        background: url("../../assets/img/property-2021/bg_time.png") no-repeat
          left top;
        background-size: 100% auto;
        width: 670px;
        font-size: 20px;
        font-family: DIN;
        font-weight: bold;
        color: #ffffff;
        line-height: 30px;
        display: flex;
        align-items: center;
      }
      .time-icon {
        display: inline-block;
        width: 17px;
        height: 17px;
        background: url("../../assets/img/property/time.png") no-repeat;
        background-size: cover;
        margin: 0 8px 0 20px;
      }
      .addr-icon {
        display: inline-block;
        width: 16px;
        height: 18px;
        background: url("../../assets/img/property/location.png") no-repeat;
        background-size: cover;
        margin: 0 8px 0 20px;
      }
      .line-icon {
        display: inline-block;
        height: 12px;
        width: 1px;
        background: #ffffff;
        margin-left: 20px;
      }
      .addr-text {
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        max-width: 400px;
        height: 30px;
        overflow: hidden;
      }
      .time-line {
        display: flex;
        justify-content: space-between;
        padding-top: 30px;
        ul {
          flex: 1;
          li {
            display: flex;
            justify-content: space-between;
            &:not(:last-child) {
              margin-bottom: 10px;
            }
            .time-num {
              font-family: DIN;
              font-style: italic;
              font-size: 16px;
              color: #333333;
              line-height: 16px;
              // margin-right: 130px;
            }
            .time-text {
              width: 150px;
              text-align: right;
            }
          }
        }
      }
    }

    .sec-03 {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 70px 100px 49px;
      background: #fff;
      .part {
        width: 50%;
        margin-bottom: 30px;
        h3 {
          font-size: 20px;
          font-weight: 600;
          color: #407afa;
          margin: 0;
          position: relative;
          width: 423px;
          line-height: 25px;
          &:before {
            content: "";
            display: inline-block;
            height: 19px;
            width: 36px;
            position: absolute;
            left: -50px;
            top: 3px;
          }
        }
        p {
          font-size: 16px;
          color: #333333;
          line-height: 26px;
          margin: 16px 0;
          text-align: justify;
          width: 423px;
        }
        &.part-1 img {
          height: 129px;
        }
        &.part-other {
          padding-left: 54px;
          box-sizing: border-box;
        }
        &.part-2 h3:before {
          background: url("../../assets/img/property-2021/num_1.png") no-repeat;
          background-size: cover;
        }
        &.part-3 h3:before {
          background: url("../../assets/img/property-2021/num_2.png") no-repeat;
          background-size: cover;
        }
        &.part-4 h3:before {
          background: url("../../assets/img/property-2021/num_3.png") no-repeat;
          background-size: cover;
        }
      }
    }

    .sec-02 {
      background: url("../../assets/img/property-2021/bg_theme.png") no-repeat
        top left;
      background-size: 100% 100%;
      /*height: 341px;*/
      padding: 40px;
      box-sizing: border-box;
      position: relative;
    }
    .title-tip {
      height: 49px;
      display: block;
      margin: 39px auto 0;
    }
    .bg-decorate {
      width: 90px;
      position: absolute;
      top: -20px;
      left: 86px;
    }

    .sec-01 {
      padding: 64px 0 91px;
      background-color: #fff;
    }

    // 轮播图
    .swiper-item-text {
      width: 500px;
      position: absolute;
      bottom: 40px;
      left: 60px;
    }
    .swiper-item-text h3 {
      font-size: 18px;
      color: #ffffff;
      line-height: 24px;
      margin-bottom: 11px;
    }
    .swiper-item-text p {
      font-size: 14px;
      color: #ffffff;
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .swiper-img-wrap {
      width: 100%;
      height: 488px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    .swiper-img-wrap:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background: url("../../assets/img/property/news_banner_mask.png")
        no-repeat;
      background-size: cover;
    }

    .swiper-img-wrap img {
      width: 100%;
      max-height: unset;
      position: relative;
    }
  }
}
</style>
